module.exports = __webpack_public_path__ + "img/icon_member.6ca48141.png";